import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { POST_FETCH_SELLER_ROLE } from "../../utils/ApiUrls";
import { POST } from "../../utils/webService";
import { toast } from "react-hot-toast";
import { decryptData } from "../../utils/Helper/Filter";

let role: any;
export function checkPageAuthorized(name: any) {
  let status = false;
  name = name.toLowerCase();
  if (role) {
    for (let parent of role?.menu) {
      if (parent.name.toLowerCase() === name && parent?.isActive === true) {
        status = true;
        break;
      } else {
        if (parent?.menu?.length > 0) {
          for (let child of parent?.menu) {
            if (child.name.toLowerCase() === name && child?.isActive === true) {
              status = true;
              break;
            }
          }
          for (let child of parent?.menu?.[0]?.pages) {
            if (child.name.toLowerCase() === name && child?.isActive === true) {
              status = true;
              break;
            }
          }
        }
      }
    }
    return status;
  }
}

const initialState: any = {
  roles: [],
  isDarkStoreEnable: false,
};

export const getRoles: any = createAsyncThunk(
  "roles",
  async (id: any, thunkApi) => {
    try {
      const response = await POST(POST_FETCH_SELLER_ROLE, {});
      
      // Check if response has encrypted data
      if (!response?.data?.encryptedData) {
        throw new Error(response?.data?.message || "Failed to fetch roles");
      }
      
      // Decrypt the response data
      const data = decryptData(response?.data?.encryptedData);
      
      role = data?.data?.[0];
      
      sessionStorage.setItem(
        "isDarkStoreEnable",
        JSON.stringify(data?.data?.[0]?.isDarkStoreEnable)
      );
      sessionStorage.setItem(
        "paymentGateway",
        JSON.stringify(data?.data?.[0]?.payments)
      );
      sessionStorage.setItem(
        "companydetails",
        JSON.stringify(data?.data?.[0]?.companydetails?.[0])
      );
      sessionStorage.setItem(
        "muthootUser",
        JSON.stringify(data?.data?.[0]?.muthootUser)
      );
      return role;
    } catch (error: any) {
      // toast.error(error?.message || "Something went wrong");
      return thunkApi.rejectWithValue(error);
    }
  }
);

export const roleSlice = createSlice({
  name: "roleSlice",
  initialState: initialState,
  reducers: {},

  extraReducers(builder) {
    builder.addCase(getRoles.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(getRoles.fulfilled, (state, action) => {
      state.loading = false;
      state.roles = [action.payload];
      state.isDarkStoreEnable = action.payload?.isDarkStoreEnable ?? false;
    });
    builder.addCase(getRoles.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message ?? "Something went wrong";
    });
  },
});
